import { Component, Input } from '@angular/core';
import { CashBalance } from '../../models';

@Component({
  standalone: false,
  selector: 'mm-pal-balance-list',
  templateUrl: './pal-balance-list.component.html',
  styleUrls: ['./pal-balance-list.component.scss'],  
})
export class PalBalanceListComponent {
  @Input() balances: CashBalance[] | null;
}
